import { useHistory } from 'react-router-dom'
import { useMutation } from 'react-query'
import http from 'utils/http'
import { endpoints } from 'global/endpoints'
import { toast } from 'react-toastify'
import { routePaths } from 'global/routePaths'

const createFmAndTvs = (postData) => {
  const updatedEndpoints = endpoints.fmandtvs.base
  return http('multipart').post(updatedEndpoints, postData)
}

export function useCreateFmAndTvs() {
  const history = useHistory()

  return useMutation(createFmAndTvs, {
    onSuccess: () => {
      toast.success('Fm And Tvs has been added successfully!')
      history.push(routePaths.home.fmandtvs.base)
    },
    onError: (error) => {
      const message = error.response.data.message
      toast.error(message)
    },
  })
}
